
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import ImageSelector from '@/components/ImageSelector.vue';

  @Component({
    components: {ImageSelector},
  })
  export default class DlgEventGuestDelete extends Vue {
    @Prop({type: Object, default: null}) private event!: any;
    @Prop({type: Object, default: null}) public guest!: any;

    @Action('admin/events/removeGuest') private deleteEventGuest!: any;
    @Action('admin/events/readGuests') private readEventGuests!: any;
    @Getter('common/rules/all') private rules!: any;

    public dialog: boolean = false;
    public loading: boolean = false;

    public async del() {
      this.loading = true;
      await this.deleteEventGuest({
        id: this.event.id,
        eventGuestId: this.guest.eventGuestId,
      });
      await this.readEventGuests(this.event);
      this.dialog = false;
      this.loading = false;
    }
  }
